import { TokenIcon } from "@/components/token"
import { Token } from "@/config/tokens"
import { InvoiceItem } from "@/api/invoices"
import InvoiceItems from "./pay-items"

interface PayViewProps {
  token: Token;
  amount?: number;
  title: string;
  description: string | InvoiceItem[];
  userName: string;
  children?: React.ReactNode;
}

export default function PayFrame({
  title,
  description,
  amount,
  token,
  userName,
  children,
}: PayViewProps) {
  return (
    <div className="flex flex-col md:flex-row items-stretch flex-grow h-full">
      <div className="bg-blue-500 flex flex-col flex-grow justify-center md:w-6/12 bg-im bg-dotsRight items-center py-4">
        <div className="flex flex-col gap-6 divide-y divide-blue-400 w-10/12 md:w-6/12">
          <div className="flex flex-col gap-6">
            {amount !== undefined && (
              <div className="text-white flex flex-row gap-2 font-semibold text-2xl items-center">
                <TokenIcon name={token} />
                {amount} {token}
              </div>
            )}
            <div className="flex flex-col gap-3">
              <h1 className="text-2xl text-white font-semibold">{title}</h1>
              {typeof description === "string" ? (
                <p className="text-blue-30 text-sm">{description}</p>
              ) : (
                <InvoiceItems items={description} token={token} />
              )}
            </div>
          </div>
          <div className="pt-6">
            <p className="text-blue-30 text-sm">By {userName}</p>
          </div>
        </div>
      </div>
      <div className="bg-blue-30 flex flex-col items-center justify-center md:w-6/12 flex-grow p-4">
        <div className="w-11/12 md:w-8/12 xl:w-7/12 pb-3">{children}</div>
      </div>
    </div>
  )
}
